export default __webpack_public_path__ + "static/media/048-information.803f80de.png";